import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {NgIf} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {ButtonDirective} from 'primeng/button';
import {RouterLink} from '@angular/router';
import {FooterComponent} from '../../shared/footer/footer.component';
import {PhoneNumberComponent} from '../../components/phone-number/phone-number.component';
import {RegisterService} from '../../core/services/register-service/register.service';
import {ToastService} from '../../core/services/toast-service/ToastService';
import {LogoService} from '../../core/services/logo-service/logo.service';

@Component({
  selector: 'app-register-user',
  imports: [
    ReactiveFormsModule,
    InputText,
    NgIf,
    DropdownModule,
    ButtonDirective,
    RouterLink,
    FooterComponent,
    PhoneNumberComponent
  ],
  templateUrl: './register-user.component.html',
  styleUrl: './register-user.component.scss'
})
export class RegisterUserComponent {
  registerForm!: FormGroup;
  logoUrl: string = "../../../assets/icons/ptm-header-logo.svg";

  constructor(
    private fb: FormBuilder,
    private registerService: RegisterService,
    private toast: ToastService,
    private logoService: LogoService,
  ) {
  }

  ngOnInit(): void {
    this.logoService.logo$.subscribe((url) => {
      if (url) {
        this.logoUrl = url;
      }
    });
    this.registerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: [''],
      companyName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      countryCode: ['+91', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    });
  }

  onSubmit(): void {
    if (this.registerForm.valid) {
      let payload = {
        ...this.registerForm.value,
        number: {
          countryCode: this.registerForm?.value?.number?.countryCode,
          dialCode: this.registerForm?.value?.number?.dialCode,
          e164Number: this.registerForm?.value?.number?.e164Number,
          internationalNumber: this.registerForm?.value?.number?.internationalNumber,
          nationalNumber: this.registerForm?.value?.number?.nationalNumber,
          mobile: this.registerForm?.value?.number?.number,
        }
      }
      this.registerService.registerNow(payload).subscribe(
        (response) => {
          this.toast.showSuccess('Registration successful', 'Success');
          console.log('Response:', response);
        },
        (error) => {
          console.error('Error:', error);
          this.toast.showError('Registration failed', error?.error?.reason);
        }
      );
    } else {
      this.toast.showError('Please fill all required fields correctly', 'Form Invalid');
      console.log('Form validation errors:', this.registerForm.errors);
      this.registerForm.markAllAsTouched();
    }
  }


  isInvalid(controlName: string): boolean {
    const control = this.registerForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getFormControl(controlName: string): FormControl {
    return this.registerForm?.get(controlName) as FormControl;
  }

}
